import { Component, ViewChild } from '@angular/core';
import { CourseService } from '../services/course.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {
  selectedId: any = '';
  successFactorList: any = [];
  reportData: any = [];
  displayedColumns: string[] = ['userId', 'lastName', 'studentEmail', 'supervisorEmail', 'title', 'jobLocationID', 'jobPositionID', 'idType', 'activityCompletionDate', 'activityCompletionStatus', 'assignmentDate', 'assignmentType', 'cluster', 'perOfCompletion', 'programCompletionDate', 'programCompletionStatus', 'programId', 'programPeriod', 'programType'];
  dataSource = new MatTableDataSource<any>();
  totalData: any = 0;
  currentPage: any = 0;
  initialLoad: boolean = false;
  dashboardFilterValues: any = {
    userId: '',
    firstname: '',
    lastName: '',
    studentEmail: '',
    supervisorEmail: '',
    title: '',
    jobLocationID: '',
    jobPositionID: '',
    idType: '',
    activityCompletionDate: '',
    activityCompletionStatus: '',
    assignmentDate: '',
    assignmentType: '',
    cluster: '',
    perOfCompletion: '',
    programCompletionDate: '',
    programCompletionStatus: '',
    programId: '',
    programPeriod: '',
    programType: ''
  };

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private readonly courseService: CourseService, private readonly http: HttpClient) { }

  ngOnInit() {
    this.getAssessmentName();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  fieldListenerHome() {
    this.dataSource.filter = JSON.stringify(this.dashboardFilterValues);
  }

  createFilterHome(): (successFactorList: any, filter: string) => boolean {
    let filterFunction = function (successFactorList: any, filter: string): boolean {
      let searchTerms = JSON.parse(filter);
      return successFactorList.userId?.toLowerCase().includes(searchTerms.userId.toLowerCase())
        && successFactorList.firstname?.toLowerCase().includes(searchTerms.firstname.toLowerCase())
        && successFactorList.lastName?.toLowerCase().includes(searchTerms.lastName.toLowerCase())
        && successFactorList.studentEmail?.toLowerCase().includes(searchTerms.studentEmail.toLowerCase())
        && successFactorList.supervisorEmail?.toLowerCase().includes(searchTerms.supervisorEmail.toLowerCase())
        && successFactorList.title?.toLowerCase().includes(searchTerms.title.toLowerCase())
        && successFactorList.jobLocationID?.toString().includes(searchTerms.jobLocationID.toLowerCase())
        && successFactorList.jobPositionID?.toString().toLowerCase().includes(searchTerms.jobPositionID.toLowerCase())
        && successFactorList.idType?.toString().toLowerCase().includes(searchTerms.idType.toLowerCase())
        && successFactorList.activityCompletionDate?.toString().toLowerCase().includes(searchTerms.activityCompletionDate.toString().toLowerCase())
        && successFactorList.activityCompletionStatus?.toString().toLowerCase().includes(searchTerms.activityCompletionStatus.toString().toLowerCase())
        && successFactorList.assignmentDate?.toString().toLowerCase().includes(searchTerms.assignmentDate.toString().toLowerCase())
        && successFactorList.assignmentType?.toString().toLowerCase().includes(searchTerms.assignmentType.toString().toLowerCase())
        && successFactorList.cluster?.toString().toLowerCase().includes(searchTerms.cluster.toString().toLowerCase())
        && successFactorList.perOfCompletion?.toString().toLowerCase().includes(searchTerms.perOfCompletion.toString().toLowerCase())
        && successFactorList.programCompletionDate?.toString().toLowerCase().includes(searchTerms.programCompletionDate.toString().toLowerCase())
        && successFactorList.programCompletionStatus?.toString().toLowerCase().includes(searchTerms.programCompletionStatus.toString().toLowerCase())
        && successFactorList.programId?.toString().toLowerCase().includes(searchTerms.programId.toString().toLowerCase())
        && successFactorList.programPeriod?.toString().toLowerCase().includes(searchTerms.programPeriod.toString().toLowerCase())
        && successFactorList.programType?.toString().toLowerCase().includes(searchTerms.programType.toString().toLowerCase())

    }
    return filterFunction;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  getAssessmentName() {
    this.courseService.getSuccessFactor().subscribe({
      next: data => {
        this.successFactorList = data;
      },
      error: error => {
      }
    })
  }

  getReportData() {
    this.reportData = [];
    this.dataSource.data = [];
    this.courseService.getReportData(this.selectedId, this.currentPage).subscribe({
      next: (data: any) => {
        console.log(data);
        this.initialLoad = true;
        this.totalData = data.pageCount;
        this.reportData = data.data;
        this.dataSource = new MatTableDataSource<any>(this.reportData);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = this.createFilterHome();
        this.fieldListenerHome();
      },
      error: error => {
      }
    })
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.currentPage = event.pageIndex;
    this.courseService.getReportData(this.selectedId, this.currentPage).subscribe({
      next: (data: any) => {
        console.log(data);
        this.reportData = data.data;
        this.dataSource = new MatTableDataSource<any>(this.reportData);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = this.totalData;
        });
      },
      error: error => {
      }
    })
  }
}